
var GA4FbLinetag = [
	{ ga4: 'login_訪客', lineTag: 'LoginVisitor' },
	{ ga4: 'login_Google', lineTag: 'LoginGoogle' },
	{ ga4: 'login_Line', lineTag: 'LoginLine' },
	{ ga4: 'login_直客', lineTag: 'LoginB2C' },
	{ ga4: 'login_企業', lineTag: 'LoginB2E' },
	{ ga4: 'login_同業', lineTag: 'LoginB2B' },
	{ ga4: 'share_Line', lineTag: 'ShareLine' },
	{ ga4: 'share_fb', lineTag: 'ShareFb' },
	{ ga4: 'favorite', lineTag: 'Favorite' },
	{ ga4: 'order_訂購_直客', lineTag: 'OrderProductB2C' },
	{ ga4: 'order_訂購_企業', lineTag: 'OrderProductB2E' },
	{ ga4: 'order_訂購_同業', lineTag: 'OrderProductB2B' },
	{ ga4: 'order_送出表單_直客', lineTag: 'OrderFormB2C' },
	{ ga4: 'order_送出表單_企業', lineTag: 'OrderFormB2E' },
	{ ga4: 'order_送出表單_同業', lineTag: 'OrderFormB2B' },
	{ ga4: 'order_訂購完成_直客', lineTag: 'OrderFinishB2C' },
	{ ga4: 'order_訂購完成_企業', lineTag: 'OrderFinishB2E' },
	{ ga4: 'order_訂購完成_同業', lineTag: 'OrderFinishB2B' },
	{ ga4: 'pay_訂金_信用卡', lineTag: 'PayDepositCreditCard' },
	{ ga4: 'pay_全額_信用卡', lineTag: 'PayFullCreditCard' },
	{ ga4: 'pay_分開付款', lineTag: 'PayCoin' },
	{ ga4: 'pay_訂金_LinePay', lineTag: 'PayDepositLinePay' },
	{ ga4: 'pay_全額_LinePay', lineTag: 'PayFullLinePay' },
	{ ga4: 'pay_匯款', lineTag: 'PayRemittance' }
];

/**
 * google analytics 自訂事件
 * @param {string} name 事件名稱
 * @param {string} tourCode 團號
 * @param {string} value 值
 *   travel_no 團號
 *   value 價錢
 */
export const googleAnalyticsEvent = ({name, tourCode, value}) => {
 
  console.log('%c== google analytics 自訂事件 ==', 'color: red');
  console.log('name', name);
  console.log('tourCode', tourCode);
  console.log('value', value);

  try {
    value
		? window.gtag('event', `web_${name}`, {...value})
		: window.gtag('event', `web_${name}`)
  } catch (e) {
    return null;
  }


  /**
   * fb 事件
   * 舊 3472609109528256
   * 新 2107784782932102
   */
  value
  ? window.fbq('trackCustom', `web_${name}`, {...value})
  : window.fbq('trackCustom', `web_${name}`)

  
  /** Line 事件 */
  let lineObj = GA4FbLinetag.find(item => item.ga4 === name);
  console.log('lineObj', lineObj);
  if(lineObj) {
    console.log('Line tag', lineObj.lineTag);
    window._lt('send', 'cv', {
      type: lineObj.lineTag
    },['b6238bb1-3f06-423a-8733-20d56e4def15']);
  }

}


/**
 * google analytics 內容群組
 * @param {string} group 國家
 * @param {array} area 國家/地區/城市
 */
/*
export const googleAnalyticsContentGroup = ({group, area}) => {
  console.log('google analytics 內容群組', group, area);
  try {
    let _group = group === '大陸' ? '中國' : group;
    window.gtag('event', 'page_view', { 'content_group': _group, });

    window.gtag('set', {
      'content_group_country': area[0],
      'content_group_city': area[2],
      'content_group_region': area[1]
    });
  } catch (e) {
    return null;
  }

}
*/